import { getLanguageAndQueryParams } from '../helpers/language';
import { getOrCreateEncodedUUID } from '../helpers/user-meta';
import { getClientHost } from '../helpers/client';

import { sortPollOptions } from './poll.helpers';

/**
 * Fetches poll data from API
 *
 * @param {string} pollId - FEK poll ID
 * @param {boolean} isTrivia - flag whether trivia or poll activation
 * @param {boolean} isGated - flag whether the poll is gated behind a login
 * @param {string} authHeader - auth header if the poll is gated
 */
export const getPollData = (pollId, isTrivia, isGated, authHeader) => {
    const { queryParams } = getLanguageAndQueryParams();
    const userId = getOrCreateEncodedUUID();

    const pollEndpoint = isGated
        ? `https://${getClientHost()}${
              process.env.API_PATH
          }/gated/polls/${pollId}${queryParams}`
        : `https://${getClientHost()}${
              process.env.API_PATH
          }/polls/${pollId}${queryParams}`;

    const triviaEndpoint = isGated
        ? `https://${getClientHost()}${
              process.env.API_PATH_TRIVIA
          }/gated/trivia/${pollId}${queryParams}`
        : `https://${getClientHost()}${
              process.env.API_PATH_TRIVIA
          }/trivia/${pollId}${queryParams}`;

    const endpoint = isTrivia ? triviaEndpoint : pollEndpoint;

    const headers = {
        'Content-Type': 'application/json',
        ...(!isGated && { 'X-User-Id': userId })
    };

    if (isGated && authHeader) {
        headers.Authorization = authHeader;
    }

    return new Promise((resolve, reject) => {
        fetch(endpoint, {
            headers
        })
            .then((response) => {
                if (!response.ok) {
                    console.warn('FEK poll embed unsuccessful', pollId);
                    return null;
                }

                return response.json();
            })
            .then((pollData) => {
                if (!pollData) {
                    return;
                }

                sortPollOptions(pollData);

                resolve(pollData);
            })
            .catch((error) => {
                console.error('Playbook - poll embed unsuccessful', error);
                reject(error);
            });
    });
};
